import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  title,
  description,
  actions,
  noPadding = false
}: CardProps) {
  return <div className={`bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-300 ${className}`} data-id="element-410">
      {(title || actions) && <div className="px-6 py-5 border-b border-slate-50 flex justify-between items-start sm:items-center gap-4" data-id="element-411">
          <div data-id="element-412">
            {title && <h3 className="text-lg font-bold text-slate-900 tracking-tight" data-id="element-413">
                {title}
              </h3>}
            {description && <p className="mt-1 text-sm text-slate-500" data-id="element-414">{description}</p>}
          </div>
          {actions && <div className="flex items-center gap-2" data-id="element-415">{actions}</div>}
        </div>}
      <div className={noPadding ? '' : 'p-6'} data-id="element-416">{children}</div>
    </div>;
}